import { FC, ReactElement } from 'react'
import Skeleton from '../skeleton'
import { LoadingElement } from './styles'

const PlanHorizontalLoading: FC = (): ReactElement => {
  return (
    <LoadingElement>
      <Skeleton />
    </LoadingElement>
  )
}

export default PlanHorizontalLoading
